import { makeAutoObservable } from "mobx";
import { ChatMessageDTO, ChatQueryParams } from "../../models/Chat";
import { ChatApi } from "../../apis/Chat";
import dayjs, { Dayjs } from 'dayjs';

export class ChatManagementPageModel {
    messages: ChatMessageDTO[] = [];
    sellerMessages: ChatMessageDTO[] = [];
    buyerMessages: ChatMessageDTO[] = [];
    currentTab: number = 0;
    queryParams: ChatQueryParams = {};
    sellerQueryParams: ChatQueryParams = {};
    buyerQueryParams: ChatQueryParams = {};
    loading: boolean = false;
    error: string | null = null;

    constructor() {
        console.log('ChatManagementPageModel 初始化');
        makeAutoObservable(this);
    }

    // 转换查询参数中的日期格式
    private convertQueryParams(params: any): ChatQueryParams {
        const converted = { ...params };
        if (converted.startTime instanceof Date) {
            converted.startTime = dayjs(converted.startTime).format('YYYY-MM-DD HH:mm:ss');
        }
        if (converted.endTime instanceof Date) {
            converted.endTime = dayjs(converted.endTime).format('YYYY-MM-DD HH:mm:ss');
        }
        return converted;
    }

    // 加载双方对话记录
    async loadRoomMessages(): Promise<void> { 
        this.error = null;
        try {
            const params = this.convertQueryParams(this.queryParams);
            const data = await ChatApi.getRoomMessagesByUser(params);
            if (data) {
                this.messages = data;
            }
        } catch (error) {
            console.error('加载对话记录失败:', error);
            this.error = error instanceof Error ? error.message : '加载失败';
        } 
    }

    // 加载卖家消息
    async loadSellerMessages(): Promise<void> { 
        this.error = null;
        try {
            const params = this.convertQueryParams(this.sellerQueryParams);
            const data = await ChatApi.getMessagesBySeller(params);
            if (data) {
                this.sellerMessages = data;
            }
        } catch (error) {
            console.error('加载卖家消息失败:', error);
            this.error = error instanceof Error ? error.message : '加载失败';
        }  
    }

    // 加载买家消息
    async loadBuyerMessages(): Promise<void> { 
        this.error = null;
        try {
            const params = this.convertQueryParams(this.buyerQueryParams);
            const data = await ChatApi.getMessagesByBuyer(params);
            if (data) {
                this.buyerMessages = data;
            }
        } catch (error) {
            console.error('加载买家消息失败:', error);
            this.error = error instanceof Error ? error.message : '加载失败';
        } 
    }

    // 根据当前Tab加载对应数据
    async loadDataByCurrentTab(): Promise<void> {
        switch (this.currentTab) {
            case 0:
                await this.loadRoomMessages();
                break;
            case 1:
                await this.loadSellerMessages();
                break;
            case 2:
                await this.loadBuyerMessages();
                break;
        }
    }

    // 重置查询条件
    resetQueryParams(): void {
        this.queryParams = {};
        this.sellerQueryParams = {};
        this.buyerQueryParams = {};
    }
} 

export const chatManagementPageModel = new ChatManagementPageModel();